export class HandAccesibility {
  public static DomObject = [
      { front: 'home', object: 'textDescriptionInfo'}, //Inicio
      { front: 'home', object: 'btn-Aceptar-Modal'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Logo'}, //Inicio
      { front: 'home', object: 'notify_button'}, //Inicio
      //{ front: 'home', object: 'Titulo Notificaciones'}, //Inicio
      { front: 'home', object: 'NotifyLink'}, //Inicio
      { front: 'home', object: 'activate-info-user'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Informacion Empresa NavBar'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Cerrar-Sesion'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Cerrar-Sesion Button'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Menu Nav-Inicio'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Menu Nav-InfoBussines'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Menu Nav-InfoWorker'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Menu Nav-Affiliation-Retreat'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Menu Nav-Affiliation'}, //Inicio
      { front: 'home', object: 'PTEC-Menu_Header Nav-CustomerService'}, //Inicio
      { front: 'home', object: 'PTEC-Menu_Header Nav-Congrats'}, //Inicio
      { front: 'home', object: 'Header_PTEC-Ir A'}, //Inicio

      { front: 'home-left', object: 'Menu Lateral_PTEC-Menu Izquierda Afiliación'}, //Inicio
      { front: 'home-left', object: 'Menu Lateral_PTEC-Menu Izquierda Descarga'}, //Inicio
      { front: 'home-left', object: 'Menu Lateral_PTEC-Descarga Certificado de afiliación empresa'}, //Inicio
      { front: 'home-left', object: 'Menu Lateral_PTEC-Descarga Certificado de afiliación trabajador'}, //Inicio
      { front: 'home-left', object: 'font-size-ajustA-'}, //Inicio
      { front: 'home-left', object: 'font-size-ajustA'}, //Inicio
      { front: 'home-left', object: 'font-size-ajustA+'}, //Inicio
      { front: 'home-left', object: 'invert-contrast'}, //Inicio
      { front: 'home-left', object: 'Consulta Afiliaciones Empleados'}, //Inicio
      { front: 'home-left', object: 'IMG_Exclamation consulta afiliaciones'}, //Inicio

      { front: 'home-right', object: 'Accesos Rapidos _PTEC-Menu Derecha AffiliateWorker'}, //Inicio
      { front: 'home-right', object: 'Accesos Rapidos _PTEC-Menu Derecha MassAffiliate'}, //Inicio
      { front: 'home-right', object: 'Accesos Rapidos _PTEC-Menu Derecha AffiliateDocument'}, //Inicio
      { front: 'home-right', object: 'Accesos Rapidos _PTEC-Menu Derecha Worker'}, //Inicio
      { front: 'home-right', object: 'Consulta Afiliaciones Beneficiarios'}, //Inicio
      { front: 'home-right', object: 'IMG_Exclamation consulta masiva'}, //Inicio

      //{ front: 'home-retreat', object: 'IMG_Exclamation consulta desafliacion'}, //Inicio

      { front: 'calendar', object: 'GoTo_Month_Before'}, //Inicio
      { front: 'calendar', object: 'GoTo_Month_After'}, //Inicio

      { front: 'info-bussiness', object: 'boxDataInfo'}, //Información de empresa
      { front: 'info-bussiness', object: 'Informacion Empresa_PTEC-Informacion Empresa Superior'}, //Información de empresa

      //typeQueryAffiliation
      { front: 'consult-worker', object: 'typeQueryAffiliation'},  //Información del trabajador
      { front: 'consult-worker', object: 'rbSiAffilite'},  //Información del trabajador
      { front: 'consult-worker', object: 'individual'},  //Información del trabajador
      { front: 'consult-worker', object: 'idTypePerson'},  //Información del trabajador
      { front: 'consult-worker', object: 'idPerson'},  //Información del trabajador
      { front: 'consult-worker', object: 'btn-siguiente'},  //Información del trabajador
      { front: 'consult-worker', object: 'btn-Informacion-Trabajadores'},  //Información del trabajador

      { front: 'affiliation', object: 'Afiliacion_PTEC-afiliacion individual'},  //Afiliación de Trabajadores
      { front: 'affiliation', object: 'Afiliacion_PTEC-afiliacion Mass'},  //Afiliación de Trabajadores

      { front: 'affiliation-one', object: 'idTypePerson'},  //afiliación del trabajador
      { front: 'affiliation-one', object: 'idPerson'},  //afiliación del trabajador
      { front: 'affiliation-one', object: 'btn-siguiente'},  //afiliación del trabajador

      { front: 'affiliation-one-detail', object: 'TipoIdTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'NumIdTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'GeneroTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'NacionalidadTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Apellido1Trabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Apellido2Trabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Nombre1Trabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Nombre2Trabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'divFechaNaciTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'FechaNaciTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'EstadoCivilTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'DepartamentoResTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'CiudadResTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'HorasLabMesTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipoContraTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'SalarioTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipSalarioTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'FechaIngresoTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipoActTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'DireccionResTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TelefonoResTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TelefonoCelTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'EmailTrabajador'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipoIdConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'NumIdConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'GeneroConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'FechaNaciConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Apellido1Conyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Apellido2Conyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Nombre1Conyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'Nombre2Conyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'OcupacionConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipoIdEmpresaConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'NumIdEmpresaConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'RazonEmpresaConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'TipoSalarioConyuge'},  //afiliación del trabajador
      { front: 'affiliation-one-detail', object: 'SalarioConyuge'},  //afiliación del trabajador
      //{ front: 'affiliation-one-detail', object: 'rbSiAffilite'},  //afiliación del trabajador

      { front: 'affiliation-buttons', object: 'Afiliacion_PTEC-afiliar-trabajador-agregar'},  //afiliación del trabajador
      { front: 'affiliation-buttons', object: 'Afiliacion_PTEC-afiliar-trabajador-regresar'},  //afiliación del trabajador
      { front: 'affiliation-buttons', object: 'Afiliacion_PTEC-afiliar-trabajador_paso:(Datos empleado) Button'},  //afiliación del trabajador

      { front: 'affiliation-one-benefit', object: 'ParentescoPerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'TipoIdPerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'NumIdPerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'GeneroPerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'Apellido1PerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'Apellido2PerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'Nombre1PerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'Nombre2PerCarg'},  //afiliación del trabajador
      { front: 'affiliation-one-benefit', object: 'FechaNaciPerCarg'},  //afiliación del trabajador


      { front: 'worker-information-query-filter', object: 'Tarjeta de afiliación multiservicio TAMS'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Abono subsidio familiar'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Abono subsidio escolar'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Estado de cuenta'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Desde'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Hasta'},  //afiliación del trabajador
      { front: 'worker-information-query-filter', object: 'Informacion Trabajadores_PTEC-Filtros de consulta'},  //afiliación del trabajador

      { front: 'mass-affiliation', object: 'Menu Lateral_PTEC-Menu Izquierda Afiliación'}, //Inicio
      { front: 'mass-affiliation', object: 'Menu Lateral_PTEC-Menu Izquierda Descarga'}, //Inicio
      { front: 'mass-affiliation', object: 'Afiliacion_PTEC-afiliacion MassDownload'},  //afiliación del trabajador
      { front: 'mass-affiliation', object: 'uploadFileMass'},  //afiliación del trabajador
      { front: 'mass-affiliation', object: 'Afiliacion_PTEC-afiliacion MassSend'},  //afiliación del trabajador
      { front: 'mass-affiliation', object: 'Afiliacion_PTEC-afiliacion Help'},  //afiliación del trabajador

      { front: 'pqrs', object: 'PQRS_Inicio'},  //Servicios atención al cliente
      { front: 'pqrs', object: 'PQRS_Inicio Consultar'},  //Servicios atención al cliente

      { front: 'notificacion-fss', object: 'ext'},  //notificacion fss
      { front: 'notificacion-fss', object: 'celphone'},  //notificacion fss
      { front: 'notificacion-fss', object: 'requestType'},  //notificacion fss
      { front: 'notificacion-fss', object: 'category'},  //notificacion fss
      { front: 'notificacion-fss', object: 'comments'},  //notificacion fss
      { front: 'notificacion-fss', object: 'attachmentFile'},  //notificacion fss
      { front: 'notificacion-fss', object: 'PQRS_Clic-Volver-Inicio'},  //notificacion fss
      { front: 'notificacion-fss', object: 'PQRS_Clic-Enviar'},  //notificacion fss

      { front: 'mass-consultation', object: 'afil_info'},  //informacion-trabajador/consulta-demografica

      { front: 'mass-consultation-affiliations', object: 'cbcertificado'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'radiocon'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'radioconind'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'radioind'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'titulo_afiliacion'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'rango_afiliacion'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'recordatorio_rango'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'fecha_inicialAfiliacion'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'fecha_finalAfiliacion'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'titulo_formato_descarga'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'mensaje_seleccion_descarga'},  //informacion-trabajador/consulta-demografica

      { front: 'mass-consultation-affiliations', object: 'radio_excel'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'radio_csv'},  //informacion-trabajador/consulta-demografica
      { front: 'mass-consultation-affiliations', object: 'btn-consulta-afiliaciones'},  //informacion-trabajador/consulta-demografica

      { front: 'validate-user', object: 'individual'},  //Validate user
      { front: 'validate-user', object: 'masiva'},  //Validate user
      { front: 'validate-user', object: 'idTypePerson'},  //Validate user
      { front: 'validate-user', object: 'idPerson'},  //Validate user
      { front: 'validate-user', object: 'btn-siguiente'},  //Validate user
      { front: 'validate-user', object: 'Validate-User-GoToHome'},  //Validate user
      { front: 'validate-user', object: 'Validate-User-Other'},  //Validate user
      { front: 'validate-user', object: 'Validate-User-Other-Affiliate'},  //Validate user

      { front: 'query-result', object: 'Informacion Trabajadores_PTEC-Resultado-Descargar-Certificado'},  // query result
      { front: 'query-result', object: 'Informacion Trabajadores_PTEC-Resultado-Agregar-Trabajador'},  // query result
      { front: 'query-result', object: 'QueryResultInfo'},  // query result

      { front: 'query-beneficiary', object: 'Consultar_mas_detalle_grupo_familiar'},  // query result


      { front: 'affilliates-detail', object: 'radicado'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'fecha'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'estado'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Afiliaciones_PTEC-Historico de afiliacion'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Afiliaciones_PTEC-Historico Limpiar'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Accesos Rapidos _PTEC-Menu Derecha Afiliar trabajador'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Accesos Rapidos _PTEC-Menu Derecha Afiliación masiva'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Accesos Rapidos _PTEC-Menu Derecha Certificado afiliación'},  // affiliates - detail
      { front: 'affilliates-detail', object: 'Accesos Rapidos _PTEC-Menu Derecha Trabajadores'},  // affiliates - detail

      { front: 'affilliates-detail-buttons', object: 'Afiliaciones_PTEC-Histórico de afiliacion nueva'},  // affiliates - detail
      { front: 'affilliates-detail-buttons', object: 'Afiliaciones_PTEC-Histórico de afiliaciones consulta'},  // affiliates - detail


      /*consulta masiva*/
      { front: 'query-mass-affiliation', object: 'code'},  //afiliación del trabajador
      { front: 'query-mass-affiliation', object: 'fecha_inicio'},  //afiliación del trabajador
      { front: 'query-mass-affiliation', object: 'fecha_fin'},  //afiliación del trabajador
      { front: 'query-mass-affiliation', object: 'estado'},  //afiliación del trabajador
      { front: 'query-mass-affiliation', object: 'btn-query-mass'},  //afiliación del trabajador
      { front: 'query-mass-affiliation', object: 'btn-query-clear-mass'},  //afiliación del trabajador


  ];

  public static DomObjectClass = [
    { front: 'home', object: 'btn-nav'}, //Inicio
    { front: 'process', object: 'btn-nav-proccess'},
    { front: 'retrat', object: 'btn-nav-retreat'},
    { front: 'affiliates-detail', object: 'icon-tblhistory'},

  ];

  public static TitlePages = [
    { page: '/tablero/inicio', title : 'Página principal - Inicio'},
    { page: '/informacion-empresas/inicio', title : 'Información de Empresa'},
    { page: '/informacion-trabajador/consultar-trabajador', title : 'Información del trabajador'},
    { page: '/tablero/afiliacion', title : 'Afiliación de trabajadores'},
    { page: '/tablero/retiro', title : 'Retiro de trabajadores'},
    { page: '/pqrs/inicio', title : 'Servicios al cliente'},
    { page: '/afiliacion-individual/inicio', title : 'Afiliación individual de Trabajadores'},
    { page: '/afiliacion-masiva/inicio', title : 'Afiliación masiva de trabajadores'},
    { page: '/retiro-individual/inicio', title : 'Retiro individual de Trabajadores'},
    { page: '/retiro-masivo/inicio', title : 'Retiro masivo de trabajadores'},
    { page: '/certificado/certificado-afiliacion-empresa', title : 'Descarga de certificado de afiliación empresarial'},
    { page: '/certificado/consultar-trabajador?id=trabajador', title : 'Descarga de certificado de afiliación del trabajador'},
    { page: '/usuario/cambiar-contrasena', title : 'Cambiar contraseña'},
    { page: '/informacion-trabajador/filtro-consulta', title : 'Filtrar Información de trabajadores'},
    { page: '/informacion-trabajador/resultado-consulta', title : 'Información de trabajadores'},
    { page: '/pqrs/notificacion-fss', title : 'Felicitaciones, solicitudes y sugerencias'},
    { page: '/informacion-trabajador/consulta-demografica', title : 'Consulta masiva de información de trabajadores'},
    { page: '/afiliacion-individual/formulario-afiliacion', title : 'Afiliación individual de trabajadores'},
    { page: '/retiro-individual/error', title : 'Retiro individual de trabajadores'},
    { page: '/retiro-individual/list-request', title : 'solicitudes de retiro individual de trabajadores'},
    { page: '/retiro-individual/formulario-retiro', title : 'solicitudes de retiro individual de trabajadores'},
    { page: '/retiro-individual/afiliacion-exitosa', title : 'solicitud exitosa'},
    { page: '/afiliacion-beneficiario/afiliacion-exitosa', title : 'solicitud exitosa'},
    { page: '/afiliacion-beneficiario/formulario-afiliacion', title : 'afiliar'},
    { page: '/afiliacion-beneficiario/formulario-afiliacion-editar', title : 'editar'},
    { page: '/retiro-beneficiario/inicio', title : 'retirar'},
    { page: '/retiro-beneficiario/nuevo', title : 'nuevo retiro'},

  ];

  public static DomObjectExclude = [
    { object: 'Afiliacion_PTEC-afiliar-trabajador-regresar'},
    { object: 'Informacion Trabajadores_PTEC-Resultado de consulta-Descarga de certificados'},
    { object: 'PTEC-Resultado de consulta-Descarga consulta'},
    { object: 'QueryDetailBackHome'},
    { object: 'QueryDetailBackHistory'},
    { object: 'Informacion Empresa_PTEC-Informacion Empresa Superior'},
    { object: 'Informacion Empresa_PTEC-Informacion Empresa'},
    { object: 'Consultar_mas_detalle_grupo_familiar'},
    { object: 'btn-consult'},

    { object: 'ext'},  //notificacion fss
    { object: 'celphone'},  //notificacion fss
    { object: 'requestType'},  //notificacion fss
    { object: 'category'},  //notificacion fss
    { object: 'comments'},  //notificacion fss
    { object: 'attachmentFile'},  //notificacion fss
    { object: 'PQRS_Clic-Volver-Inicio'},  //notificacion fss
    { object: 'PQRS_Clic-Enviar'},  //notificacion fss
    { object: 'IMG_Exclamation consulta desafliacion'},
    { object: 'codeSettled'},
    { object: 'dateStart'},
    { object: 'dateEnd'},
    { object: 'status'},
    { object: 'btn_back_home'},
    { object: 'btn_make_query'},
    { object: 'btn_make_query'},
    { object: 'Retiro_PTEC-retiro Masivo cancelar'},
    { object: 'Retiro_PTEC-retiro individual'},
    { object: 'Retiro_PTEC-retiro Mass'},
    { object: 'Retiro_PTEC-retiro Help'},
    { object: 'btn-back-home-from-radicate'},
    { object: 'btn-request-new-from-radicate'},
    { object: 'btn-request-new-from-radicate'},

    //Retiro_PTEC-retiro Masivo

    //{ object: 'Informacion Trabajadores_PTEC-Resultado-Descargar-Certificado'},
    //{ object: 'Informacion Trabajadores_PTEC-Resultado-Agregar-Trabajador'},
    //{ object: 'Accesos Rapidos _PTEC-Menu Derecha AffiliateDocument'},
    //{ object: 'Accesos Rapidos _PTEC-Menu Derecha Worker'},
  ];

  public static INITIAL_FOCUS = 16;
}
